'use es6';

import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import memoize from './memoize';
import * as PartnerTypes from '../constants/solutions/PartnerType';
import formatName from 'I18n/utils/formatName';
export const getSuperCategoryI18nKey = superCategory => {
  return `ecosystemMarketplaceCore.groupTags.superCategory.${superCategory}`;
};
export const getCategoryI18nKey = category => {
  return `ecosystemMarketplaceCore.groupTags.category.${category}`;
};
export const getCategoryFeatureI18nKey = (category, feature) => {
  return `ecosystemMarketplaceCore.groupTags.categoryFeature.${category}.${feature}`;
};
export const getTierI18nKey = tier => {
  return `ecosystemMarketplaceCore.groupTags.tier.${tier}`;
};
export const getTierHubI18nKey = hub => {
  return `ecosystemMarketplaceCore.groupTags.tierHub.${hub}`;
};
export const getTierLevelI18nKey = level => {
  return `ecosystemMarketplaceCore.groupTags.tierLevel.${level}`;
};
export const getHubSpotFeatureGroupI18nKey = key => {
  return `ecosystemMarketplaceCore.groupTags.hubspotFeatureGroups.${key}`;
};
export const getHubSpotFeatureI18nKey = key => {
  return `ecosystemMarketplaceCore.groupTags.hubspotFeature.${key}`;
};
export const getDataSyncsDataI18nKey = data => {
  return `ecosystemMarketplaceCore.dataSyncs.data.${data}`;
};
export const getDataSyncsSyncI18nKey = sync => {
  return `ecosystemMarketplaceCore.dataSyncs.sync.${sync}`;
};
export const getAssetBusinessTypeI18nKey = (businessType, sentenceCase = true) => `ecosystemMarketplaceCore.assets.businessType.${businessType}.${sentenceCase ? 'sentence' : 'title'}`;
export const getAssetPageTypeI18nKey = (pageType, sentenceCase = true) => `ecosystemMarketplaceCore.assets.pageType.${pageType}.${sentenceCase ? 'sentence' : 'title'}`;
export const getAssetPageFeatureI18nKey = (feature, sentenceCase = true) => `ecosystemMarketplaceCore.assets.pageFeature.${feature}.${sentenceCase ? 'sentence' : 'title'}`;
export const getRoleI18nKey = memoize((role, portalScopes) => {
  let key = role.toLowerCase().replace(/ /g, '-');

  if (portalScopes) {
    if (portalScopes.includes('sales-nav-access')) {
      key += '-sales';
    } else if (portalScopes.includes('service-access')) {
      key += '-service';
    }
  }

  return `roles.${key}`;
});
export const getProfileTierLabelI18nKey = (tier, partnerType, labelKey) => {
  const I18N_BASE = 'ecosystemMarketplaceCore.solutions.profileTier';

  switch (partnerType) {
    case PartnerTypes.PROVIDER:
      {
        return `${I18N_BASE}.${PartnerTypes.PROVIDER}.${labelKey}`;
      }

    case PartnerTypes.PARTNER:
    case PartnerTypes.RESELLER:
      {
        return `${I18N_BASE}.${PartnerTypes.PARTNER}.${tier}.${labelKey}`;
      }

    case PartnerTypes.DIRECTORY_USER:
    default:
      {
        return null;
      }
  }
}; // Translates a key path for a listing (e.g. ['details', 'integrationFeatures', '2', 'headline']
// into a label name "How It Works 3 - Headline" to use for listing flow, admin diff, etc.

export const getListingLabelName = (pathArr, labelPath) => {
  let pathToTranslate = labelPath;
  return pathArr.reduce((result, pathKey, index) => {
    let number;

    if (!isNaN(parseInt(pathKey, 10))) {
      number = parseInt(pathKey, 10) + 1;
      pathKey = 'index';
    }

    pathToTranslate = `${pathToTranslate}.${pathKey}`;

    if (isValidI18nKey(pathToTranslate)) {
      const translatedPath = I18n.text(pathToTranslate, {
        number
      });

      if (pathKey === 'index') {
        pathToTranslate = pathToTranslate.replace('.index', '');
      }

      if (!result) {
        return translatedPath;
      }

      return `${result} - ${translatedPath}`;
    } else if (index === pathArr.length - 1 && isValidI18nKey(`${pathToTranslate}.default`)) {
      const translatedPath = I18n.text(`${pathToTranslate}.default`, {
        number
      });

      if (!result) {
        return translatedPath;
      }

      return `${result} - ${translatedPath}`;
    } else return result;
  }, '');
};
export const getDisplayedReviewerName = ({
  firstName,
  lastName,
  legacyFullName
}) => {
  if (firstName && lastName) {
    return formatName({
      firstName,
      lastName
    });
  }

  if (legacyFullName) {
    return legacyFullName;
  }

  return I18n.text('ecosystemMarketplaceCore.reviews.defaultName');
};